<template>
  <t-form labelWidth="100px">
     <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.titleColor"/>
      </t-form-item>
      <t-form-item label="标题字体">
        <t-input-number size="small" v-model="attribute.titleSize" :min="4" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题偏移量">
        <t-input-number size="small" v-model="attribute.titleOffsetTop" :min="0" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="数值" :expand="false">
      <t-form-item label="数值颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.numColor"/>
      </t-form-item>
      <t-form-item label="数值字体">
        <t-input-number size="small" v-model="attribute.numSize" :min="4" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="数值格式化">
        <t-input size="small" v-model="attribute.format"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="进度" :expand="true">
      <t-form-item label="进度颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.progressColor"/>
      </t-form-item>
      <t-form-item label="进度背景">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.progressBg" enableAlpha/>
      </t-form-item>
      <t-form-item label="南丁格尔图">
        <t-select size="small" v-model="attribute.roseType">
          <t-option label="不展示" value="false"/>
          <t-option label="圆心角" value="radius"/>
          <t-option label="扇区" value="area"/>
        </t-select>
      </t-form-item>
      <t-form-item label="进度圆角">
        <t-input-number size="small" v-model="attribute.borderRadius" :min="0" :max="120"/>
      </t-form-item>
      <t-form-item label="进度粗细">
        <t-input-number size="small" v-model="attribute.progressWidth" :min="0" :max="90" :decimal-places="0"/>
      </t-form-item>
    </e-collapse>
    <t-form-item label="扇区边框">
      <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.borderColor"/>
    </t-form-item>
    <t-form-item label="内环显示">
      <t-switch v-model="attribute.innerRingShow" :label="['开', '关']" size="small"/>
    </t-form-item>
    <e-collapse title="条件配色" :expand="false">
      <div style="width: 100%;text-align: center;margin-bottom: 10px"><!--告警配置、环形图/进度图-->
        <t-row>
          <t-col :span="4"></t-col>
          <t-col :span="4">条件</t-col>
          <t-col :span="4">目标值</t-col>
        </t-row>
        <t-row style="margin-top: 14px;">
          <t-col :span="4">数值</t-col>
          <t-col :span="4">
            <t-select v-model="attribute.alarmConfig.operator" size="small" style="width: 80px;">
              <t-option value=">" label=">"/>
              <t-option value="<" label="<"/>
              <t-option value="=" label="="/>
              <t-option value=">=" label=">="/>
              <t-option value="<=" label="<="/>
            </t-select>
          </t-col>
          <t-col :span="4">
            <t-input-number v-model="attribute.alarmConfig.threshold" theme="normal" size="small" style="width: 100%;"/>
          </t-col>
        </t-row>
      </div>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.alarmConfig.color"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-progress-ring-option",
  components: { CptData },
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>

</style>
